<template>  
  <div class="ratio-image" :class="ratioClasses" :style="borderRadiusStyles">
    <img v-if="context !== 'pdp'" ref="image" :src="src" :alt="alt">
    <picture v-else>
      <source
        v-if="inViewIntersected"
        media="(min-width: 600px)"
        :srcset="`${imageSize(src, '600x')}, ${imageSize(src, '1200x')} 2x`"
      >
      <source
        v-if="inViewIntersected"
        media="(min-width: 500px)"
        :srcset="`${imageSize(src, '450x')}, ${imageSize(src, '900x')} 2x`"
      >
      <source
        v-if="inViewIntersected"
        media="(max-width: 499px)"
        :srcset="`${imageSize(src, '400x')}, ${imageSize(src, '800x')} 2x`"
      >
      <img
        :src="inViewIntersected ? src : ''"
        :alt="alt"
        ref="image"
      />
    </picture>
  </div>
</template>

<script>
import { imageSize } from '@/scripts/helpers/util';

export default {
  name: 'ImageRatio',
  props: {
    src: String,
    alt: String,
    ratio: String,
    seen: String,
    inverse: Boolean,
    context: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      observer: null, 
      intersected: false,
      inViewObserver: null, 
      inViewIntersected: false,
      resizeObserver: null,
      componentWidth: 0,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(entries => {
      const image = entries[0];
      if (image.isIntersecting) {
        this.intersected = true;
      }
    }, {
      rootMargin: '40px'
    });

    this.observer.observe(this.$refs.image);

    this.inViewObserver = new IntersectionObserver(entries => {
      const image = entries[0];
      if (image.isIntersecting) {
        this.inViewIntersected = true;
      }
    }, {
      rootMargin: '-10%'
    });

    this.inViewObserver.observe(this.$refs.image);

    this.resizeObserver = new ResizeObserver(entries => {
      let wrapper = entries[0];
      this.componentWidth = wrapper.contentRect.width;
    });

    this.resizeObserver.observe(this.$el)

    this.componentWidth = this.$el.offsetWidth;

  },
  computed: {
    ratioClasses() {
      switch(this.ratio) {
        case '3:5':
          return 'ratio-image--3x5';
        case '4:5':
          return 'ratio-image--4x5';
        case '3:4':
          return 'ratio-image--3x4';
        case '1:1':
          return 'ratio-image--1x1';
        default:
          return '';
      }
    },
    borderRadiusStyles() {
      let width;
      if (this.inverse) {
        width = this.inViewIntersected ? this.componentWidth : 0;
      } else {
        width = this.inViewIntersected ? 0 : this.componentWidth;
      }
      return {
        borderRadius: `${width/2}px`
      }
    }
  },
  methods: {
    imageSize,
  },
}
</script>

<style scoped lang="scss">
  .ratio-image {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    transition: all .6s $default-animation-timing, border-radius 1s $default-animation-timing;

    img {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
      top: 0;
      left: 0;
      border: 0;
    }

    &--3x5 {
      padding-top: 166.667%;
    }

    &--4x5 {
      padding-top: 125%;
    }

    &--3x4 {
      padding-top: 133.333%;
    }

    &--1x1 {
      padding-top: 100%;
    }
  }
</style>
